<template>
  <div>
    <TopHeader2 underlineItem="گالری تصاویر"></TopHeader2>
    <section class="logo-header-resp d-md-none my-5">
      <div class="mx-auto">
        <img src="@/assets/images/logos/logoBlack.png" alt="" />
      </div>
    </section>
    <main v-if="photos" class="main">
      <PagesPath :items="['گالری', 'تصاویر ']" :last="'/gallery'"></PagesPath>
      <section class="photos-grid container my-5">
        <article
          v-for="(item, index) in photos.data"
          :key="index"
          class="photo-item border text-right"
        >
          <div class="photo-item-img bg-color-c8">
            <img
                @click="showSliderFunc(index)"
             :src="item.image.url" alt="" />
          </div>
          <div class="photo-item-content p-3">
            <h6 class="fontsize-medium text-color-222">{{ item.title }}</h6>
            <div class="d-flex justify-content-between mt-5">
              <div>
                <svg 
                 class="icon ml-1" width="14" height="14">
                  <use href="@/assets/svgIcons/svgIcons.svg/#time"></use>
                </svg>
                <span class="fontsize-mini text-color-444">{{
                  new Date(item.created_at).toLocaleDateString("fa")
                }}</span>
              </div>
              <button
                class="fontsize-mini px-3"
                @click="showSliderFunc(index)"
              >
                مشاهده
              </button>
            </div>
          </div>
        </article>
      </section>
      <template  v-if="showSlider">
      
          
        
      <LightBox @onClosed="showSlider=false" :startAt="startAt" :media="images"></LightBox>
      </template>
    </main>
    <loader v-else />
  </div>
</template>

<script>
import loader from "@/components/loader.vue";

import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
import LightBox from "vue-it-bigger";
 
export default {
  name: "Photos",
  components: {
    LightBox,
    TopHeader2,
    PagesPath,
    loader
  },metaInfo() {
    return {
      title:"تصویر ها",
    
    };
  }
  ,
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type == "partner" ? "partner" : "main";
    } else {
      this.type = "main";
    }
    this.$axios
      .get(
        `/images?type=${this.type}&page=${
          this.$route.query.page ? this.$route.query.page : 1
        }`
      )
      .then((response) => {
        this.photos = response.data.images;
        this.photos.data.forEach((image) => {
          this.images.push({
            thumb: image.image.url,
            src: image.image.url,
            caption: image.title
          });
        });
      });
    document.querySelectorAll(".photo-item-img").forEach((item) => {
      item.style.height = item.offsetWidth + "px";
    });
  },
  methods: {
    showSliderFunc(index){
      this.startAt=index;
      this.showSlider=true;
    },
    changePage(event) {
      this.$axios.get(`/photos?type${this.type}&page=${event}`).then((res) => {
        this.photos = res.data.photos;
      });
      this.$router.replace({ name: "videos", query: { page: event } });
    }
  },
  data() {
    return {
      startAt:0,
      photos: null,
      images: [],showSlider:false,
      type: ""
    };
  }
};
</script>

<style scoped>
.photo-item {
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  background-color: white;
}
.photo-item-img {
  /*position: absolute;*/
  width: 100%;
}
.photo-item-img img {
  width: 100%;
  height: 100%;
}
.photos-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1.5rem;
}
.photo-item-content button {
  border-radius: 7px;
  border: 1px solid var(--color-theme);
  color: var(--color-theme);
  background-color: white;
}
.photo-item-content button:hover {
  background-color: var(--color-theme);
  color: white;
}
.logo-header-resp > div {
  width: 150px;
}
.logo-header-resp > div img {
  width: 100%;
}

@media screen and (max-width: 991px) {
  .photos-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 767px) {
  .photos-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 400px) {
  .photos-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
